import { DispatchOptions } from 'vuex';
import store from '@/store';
import {
  mainModuleStoreActionNames,
  mainModuleStoreGetterNames,
  storeNamespaces,
} from '@/entities/store.namespace';
import { Attributes } from '@/entities/page.attributes';
import PageContext from '@/entities/page..context';
import { StorageItems } from '@/entities/storage.items';
import { WidgetsInfo } from '@/entities/widget.info';
import { DEVICE } from '@/entities/device';

class StoreService {
  public async dispatchMainModule(type: string, payload?: any, options?: DispatchOptions): Promise<any> {
    const result = await store.dispatch(`${storeNamespaces.MAIN_MODULE}/${type}`, payload, options);
    return result;
  }
  public getPageAttributesMap(): Map<number, Attributes> {
    return store.getters[`${storeNamespaces.MAIN_MODULE}/${mainModuleStoreGetterNames.PAGE_ATTRIBUTES_MAP}`];
  }
  public getStorageItems(): StorageItems {
    const storageItems: StorageItems = store.getters[`${storeNamespaces.MAIN_MODULE}/${mainModuleStoreGetterNames.STORASGE_ITEMS}`];
    return storageItems;
  }
  public getDevices(): Array<DEVICE> {
    return store.getters[`${storeNamespaces.MAIN_MODULE}/${mainModuleStoreGetterNames.DEVICE}`];
  }
  public isMobileView(): boolean {
    return store.getters[`${storeNamespaces.MAIN_MODULE}/${mainModuleStoreGetterNames.IS_MOBILE_VIEW}`];
  }
  public isDesktopView(): boolean {
    return store.getters[`${storeNamespaces.MAIN_MODULE}/${mainModuleStoreGetterNames.IS_DESKTOP_VIEW}`];
  }

  public getPageContext(): PageContext {
    return store.getters[`${storeNamespaces.MAIN_MODULE}/${mainModuleStoreGetterNames.PAGE_CONTEXT}`];
  }

  public getMessages(): Map<string, string> {
    return store.getters[`${storeNamespaces.MAIN_MODULE}/${mainModuleStoreGetterNames.MESSAGES}`];
  }

  public getWidgetsInfo(): WidgetsInfo {
    return store.getters[`${storeNamespaces.MAIN_MODULE}/${mainModuleStoreGetterNames.WIDGETS_INFO}`];
  }
  public async setWidgetsInfo(widgetsInfo: WidgetsInfo): Promise<any> {
    return this.dispatchMainModule(mainModuleStoreActionNames.SET_WIDGETS_INFO, widgetsInfo);
  }
  public getApiEndpoints(): any {
    return store.getters[`${storeNamespaces.MAIN_MODULE}/${mainModuleStoreGetterNames.API_ENDPOINTS}`];
  }
  public async setApiEndpoints(apiEndpoints: any): Promise<any> {
    return this.dispatchMainModule(mainModuleStoreActionNames.SET_API_ENDPOINTS, apiEndpoints);
  }
}

// Export a singleton instance in the global namespace
export const storeService = new StoreService();

